// Dependencies
import React from 'react';
import uuid from 'react-uuid';
import PropTypes from 'prop-types';

// Components
import Container from '../../container/container';
import BlogPost from '../blogPost/blogPost';

// Hooks
import useLatestBlogPosts from '../../../hooks/useLatestBlogPosts';

// Styles
import LatestBlogPostsStyles from './blogLatestPosts.styles';

export default function BlogLatestPosts({ layout }) {
  const posts = useLatestBlogPosts();

  const heading = layout?.heading;

  return (
    <LatestBlogPostsStyles>
      <Container>
        <h2 className="heading">{heading}</h2>
      </Container>
      <Container>
        <ul className="posts">
          {!!posts?.length &&
            posts.map((post) => (
              <li key={uuid()}>
                <BlogPost large post={post} />
              </li>
            ))}
        </ul>
      </Container>
    </LatestBlogPostsStyles>
  );
}

BlogLatestPosts.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
  }),
};

BlogLatestPosts.defaultProps = {
  layout: {
    heading: 'The Latest From Our Blog',
  },
};
